import { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { PlusSvg, MinusSvg } from "@/components/svgs";

const FilterAccordion = ({ children, header, isOpen, onToggle }) => {
  return (
    <div className="mb-6 border-b border-gray-300" id={header}>
      <div className="list-none">
        <span
          className="flex relative justify-between mb-5 uppercase cursor-pointer leading-[13px] font-[400] font-[helveticaBold,_Helvetica,_sans-serif] text-[13px] text-center items-center"
          onClick={onToggle}
        >
          {header}
          {!isOpen ? <PlusSvg /> : <MinusSvg />}
        </span>
        {isOpen && <div>{children}</div>}
      </div>
    </div>
  );
};

FilterAccordion.propTypes = {
  children: PropTypes.node,
  header: PropTypes.string,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default FilterAccordion;
